import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "=w-full flex flex-col gap-[3.2rem] tablet:gap-[4rem]"
};
const _hoisted_2 = {
    key: 0,
    class: "w-full flex flex-col gap-[2.4rem]"
};
const _hoisted_3 = {
    key: 1,
    class: "w-full flex"
};
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import SpecialistBox from '@scripts/components/Specialists/SpecialistBox.vue';
export default {
    __name: 'Specialists',
    props: {
        count: {
            type: Number,
            default: 6
        },
        search: {
            type: String,
            default: null
        },
        filter: {
            type: String,
            default: null
        }
    },
    setup (__props) {
        const store = useStore();
        let specialists = computed(()=>{
            return store.state.specialists.specialists;
        });
        let meta = computed(()=>{
            return store.state.specialists.meta;
        });
        const state = ref({
            page: 2,
            loading: false
        });
        const loadSpecialists = async ()=>{
            // .value is needed in JavaScript
            state.value.loading = true;
            let data = {
                per_page: __props.count,
                page: state.value.page
            };
            if (__props.search) {
                data['search'] = __props.search;
            }
            if (__props.filter) {
                data['doctor_categories'] = __props.filter;
            }
            await store.dispatch('GetSpecialists', {
                data: {
                    ...data
                }
            }).then(()=>{
                state.value.page += 1;
            });
            state.value.loading = false;
        };
        return (_ctx, _cache)=>{
            const _directive_loading = _resolveDirective("loading");
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _unref(specialists).length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(specialists), (item)=>{
                        return _openBlock(), _createBlock(SpecialistBox, {
                            key: item.id,
                            specialist: item
                        }, null, 8, [
                            "specialist"
                        ]);
                    }), 128))
                ])) : _createCommentVNode("", true),
                state.value.page <= _unref(meta).pages || !_unref(meta).pages ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                        class: "btn btn--secondary",
                        onClick: loadSpecialists
                    }, _cache[0] || (_cache[0] = [
                        _createTextVNode("Rozwiń pozostałych specialistów")
                    ]))), [
                        [
                            _directive_loading,
                            state.value.loading
                        ]
                    ])
                ])) : _createCommentVNode("", true)
            ]);
        };
    }
};
